import { UserIcons } from "./icons";

const defaultUserSettings: {[id: string]: IObject} = {
    ADMIN: {
        id: "ADMIN",
        title: "users.administrator",
        icon: UserIcons.ADMIN,
        properties: []
    },
    CUSTOMER: {
        id: "CUSTOMER",
        title: "users.customer",
        icon: UserIcons.CUSTOMER,
        properties: []
    }
}

export const UserSettings = {
    allSettings: defaultUserSettings,
    getSettings: (id: string)=>defaultUserSettings[id]
}